import { Injectable } from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";
import { StorageMap } from "@ngx-pwa/local-storage";
import { localStorageKey } from "@core/constants";
import { Auth } from "@core/entities/auth.interface";
import { AuthService } from "@auth0/auth0-angular";
import { environment as ENV } from "@environments/environment";

@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  constructor(private storage: StorageMap, private authService: AuthService) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return this.storage.get(localStorageKey).pipe(
      switchMap((authInfo: Partial<Auth>) => {
        if (authInfo?.access_token) {
          request = request.clone({
            setHeaders: { Authorization: `Bearer ${authInfo?.access_token}` },
          });
        }

        request = request.clone({ setHeaders: { Accept: "application/json" } });

        return next.handle(request).pipe(
          map((event: HttpEvent<any>) => {
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            if (error.status === 401) {
              localStorage.clear();
              this.authService.logout({
                logoutParams: { returnTo: ENV.auth0.redirectUri },
              });
            }
            return throwError(error);
          })
        );
      })
    );
  }
}
